<template>
    <div class="content-wrapper">
        <Breadcrumbs :items="breadcrumbs"></Breadcrumbs>
        <div class="content">
            <Markers stage3 :forcedDisabledStages="forcedDisabledMarkersStages"></Markers>
            <component
                @createConnector="createConnector"
                @cancel="cancel"
                @endSettings="goToProject"
                v-if="activeComponent"
                :is="activeComponent"
            ></component>
            <h2 class="dashboard mt-12" v-else>
                В настоящее время настройки в этом источнике не поддерживается
            </h2>
        </div>
    </div>
</template>

<script>
// @ is an alias to /src
//REFACTORING: Перенести логику из первичных настроек коннекторов сюда
import { mapState, mapMutations } from 'vuex'
import Markers from '@/components/addConnector/Markers.vue'
import Breadcrumbs from '@/components/Breadcrumbs'
import settingsList from '@/components/connectorSettings/list'
import { CONNECTOR_TYPES, PROVIDER_TYPES, CHANNEL_TYPES } from '../vars/general'
import isNil from 'lodash/isNil'
import cfg from '@root/config'
export default {
    name: 'AddConnectorStage3',
    components: {
        Markers,
        Breadcrumbs,
    },
    data: () => ({
        CONNECTOR_TYPES,
        forcedDisabledMarkersStages: [],
    }),

    computed: {
        ...mapState('project', ['currentAddingConnector', 'loggedAddingConnector']),
        currentAddingConnectorType() {
            return this.loggedAddingConnector.connectorType
        },
        project() {
            return this.$store.getters.projectById(this.$router.currentRoute.params.id)
        },
        activeComponent() {
            console.log(settingsList.find(el => el.connectorType === this.currentAddingConnectorType))
            return settingsList.find(el => el.connectorType === this.currentAddingConnectorType)?.component
        },
        breadcrumbs() {
            return [
                {
                    text: this.project.name,
                    to: `/project/${this.project.id}`,
                },
                {
                    text: 'ДОБАВИТЬ ИСТОЧНИК',
                    disabled: true,
                    to: '',
                },
            ]
        },
    },
    methods: {
        cancel() {
            const projectId = this.$router.currentRoute.params.id
            this.$store.dispatch('project/deleteConnector', this.loggedAddingConnector.connectorId)
            this.$router.push(`/project/${projectId}#connectors`)
        },
        goToProject() {
            const projectId = this.$router.currentRoute.params.id
            this.$router.push(`/project/${projectId}`)
        },
        async createConnector({ settings, useRedirect }) {
            if (isNil(settings)) settings = {}
            if (isNil(useRedirect)) useRedirect = true
            settings.isDraft = false
            const connectorId = this.loggedAddingConnector.connectorId
            this.$store.commit('startLoading')
            await this.$store.dispatch('project/updateConnectorSettings', { connectorId, settings })
            this.$store.commit('endLoading')
            if (useRedirect) this.goToProject()
        },
    },
    created() {
        //Если пользователь попадает на этот экран через завершение подключения, запрещаем ему переходить на 1 и 2 подключения
        if (this.$router.currentRoute.query.complete) {
            this.forcedDisabledMarkersStages = [1, 2]
        }

        // Проверяем, является ли коннектор каналом, и если да, перенаправляем на правильную страницу
        const connector = this.loggedAddingConnector || this.currentAddingConnector
        if (connector) {
            // whatsapp (CONNECTOR_TYPES.whatsapp) и whatsappBasis создаются как источники, а не каналы
            const isWhatsappSource = connector.connectorType === CONNECTOR_TYPES.whatsapp
            const isWhatsappBasis = connector.connectorType === CONNECTOR_TYPES.whatsappBasis
            // Исключаем PROVIDER_TYPES.whatsapp и PROVIDER_TYPES.whatsappBasis из проверки
            const providerTypesWithoutWhatsapp = Object.values(PROVIDER_TYPES).filter(t => 
                t !== PROVIDER_TYPES.whatsapp && t !== PROVIDER_TYPES.whatsappBasis
            )
            const isChannel = !isWhatsappSource && !isWhatsappBasis && (
                Object.values(CHANNEL_TYPES).includes(connector.connectorType) ||
                (connector.providerType && providerTypesWithoutWhatsapp.includes(connector.providerType)) ||
                providerTypesWithoutWhatsapp.includes(connector.connectorType)
            )
            
            if (isChannel) {
                const projectId = this.$router.currentRoute.params.id
                const completeParam = this.$router.currentRoute.query.complete ? '?complete=true' : ''
                this.$router.replace(`/project/${projectId}/addChannelStage3${completeParam}`)
                return
            }
        }

        this.$on('endSettings', this.goToProject)
        this.$on('createConnector', this.createConnector)
        this.$on('goToProject', this.goToProject)
        this.$on('cancel', this.cancel)
    },
}
</script>
<style lang="sass" scoped>
.addConnector
    padding-top: 5%
    padding-left: 10%
    padding-right: 10%
.cancel-btn
    border-color: #0000001F
</style>
